import brazilFlag from '../assets/flags/br.svg';
import portugalFlag from '../assets/flags/pt.svg';
import spainFlag from '../assets/flags/es.svg';
import unitedStatesFlag from '../assets/flags/us.svg';

export const SUPPORTED_LOCALES = ['pt-BR', 'pt-PT', 'es-419', 'en-US'] as const;

export type AppLocale = typeof SUPPORTED_LOCALES[number];

export const DEFAULT_LOCALE: AppLocale = 'pt-BR';
export const ANONYMOUS_LOCALE_STORAGE_KEY = 'zenbox.locale';

export interface AppLocaleMetadata {
  code: AppLocale;
  label: string;
  flag: string;
}

export const LOCALE_METADATA: ReadonlyArray<AppLocaleMetadata> = [
  { code: 'pt-BR', label: 'Portugu\u00eas (Brasil)', flag: brazilFlag },
  { code: 'pt-PT', label: 'Portugu\u00eas (Portugal)', flag: portugalFlag },
  { code: 'es-419', label: 'Espa\u00f1ol (Latinoam\u00e9rica)', flag: spainFlag },
  { code: 'en-US', label: 'English (United States)', flag: unitedStatesFlag },
];

export const isSupportedLocale = (value: unknown): value is AppLocale =>
  typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
